import { useEffect, useRef, useState } from "react";

export function useImagePreloader(imageUrl: string) {
  const [displayUrl, setDisplayUrl] = useState(imageUrl);
  const prevUrlRef = useRef(imageUrl);
  const loadingRef = useRef(false);

  useEffect(() => {
    // Skip if the URL hasn't actually changed or is empty
    if (!imageUrl || imageUrl === prevUrlRef.current) return;

    // Skip if already loading
    if (loadingRef.current) return;

    // Mark as loading
    loadingRef.current = true;

    // Update ref to track the latest URL
    prevUrlRef.current = imageUrl;

    // For image URLs, preload then update
    if (imageUrl.startsWith("http")) {
      const img = new Image();

      img.onload = () => {
        setDisplayUrl(imageUrl);
        loadingRef.current = false;
      };

      img.onerror = () => {
        // On error, still update to show something
        setDisplayUrl(imageUrl);
        loadingRef.current = false;
      };

      img.src = imageUrl;

      return () => {
        img.onload = null;
        img.onerror = null;
      };
      // biome-ignore lint/style/noUselessElse: <explanation>
    } else {
      // For non-http URLs, update immediately
      setDisplayUrl(imageUrl);
      loadingRef.current = false;
    }
  }, [imageUrl]); // Only depend on the input URL

  return displayUrl;
}
